import { mapState } from 'vuex';
import { Vue, Options } from 'vue-class-component';
import { getPlantIconImageUrlsByType } from '@/core/utils/utils';
import Gate from './EntrancePlantDashboardGate/EntrancePlantDashboardGate.vue';
import CardContainer from '@/views/components/CardContainer/CardContainer.vue';
import {
  EntrancePlantDetailDTO,
} from 'client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import EntrancePlantStatusBanner from './EntrancePlantStatusBanner/EntrancePlantStatusBanner.vue';
import DialogAddEditGate from '../EntrancePlantGate/DialogAddEditGate/DialogAddEditGate.vue';

@Options({
  name: 'EntrancePlantDashboard',
  components: {
    Gate,
    CardContainer,
    EntrancePlantStatusBanner,
    DialogAddEditGate,
  },
  props: {},
  computed: {
    ...mapState(['currentEntrancePlant', 'adminView']),
  },
  emits: ['update-list'],
  watch: {},
})
export default class EntrancePlantDashboard extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  countBadges = 0;
  adminView!: boolean;
  isAddGateDialogVisible = false;
  gateToEdit = null;

  get imageURLs() {
    return getPlantIconImageUrlsByType(
      this.currentEntrancePlant.icon,
      this.currentEntrancePlant.customIconImageUrl,
      this.currentEntrancePlant.plantType
    );
  }

  get imageSrcSetURLs() {
    if (this.imageURLs.length <= 1) return this.imageURLs[0];
    return `${this.imageURLs[0]}, ${this.imageURLs[1]} 2x, ${this.imageURLs[2]} 3x`;
  }

  get countBuildings() {
    if (this.currentEntrancePlant.buildings === undefined) return 0;
    return this.currentEntrancePlant.buildings.length;
  }

  get countApartments() {
    if (this.currentEntrancePlant.buildings === undefined) return 0;
    let apartmentsTotal = 0;
    for (const building of this.currentEntrancePlant.buildings) {
      if (building.apartments !== undefined) {
        apartmentsTotal += building.apartments.length;
      }
    }
    return apartmentsTotal;
  }

  get noMoreScsAddresses() {
    return this.currentEntrancePlant.scsAddressHelper?.availableScsAddressGate!.length === 0;
  }

  get NoSwitchboardAddresses() {
    return this.currentEntrancePlant.scsAddressHelper?.availableScsAddressSwitchboard!.length === 0;
  }

  async mounted() {
    await this.doCountBadges();
  }

  async doCountBadges() {
    const badgesList = await plantsClient.badgeAll(
      this.currentEntrancePlant.desktopId as number
    );
    this.countBadges = badgesList.length;
  }

  toggleCreateGateDialog() {
    this.isAddGateDialogVisible = !this.isAddGateDialogVisible;
  }

  handleUpdateList() {
    this.$emit('update-list');
  }

  goToParametersSettings() {
    this.$router.push({
      name: 'page-entranceplant-settings',
    });
  }

  goToResidents() {
    this.$router.push({
      name: 'page-entranceplant-residents',
    });
  }

  goToGuests() {
    this.$router.push({
      name: 'page-entranceplant-guests',
    });
  }

  goToMessages() {
    this.$router.push({
      name: 'page-entranceplant-messages',
    });
  }

  goToBadges() {
    this.$router.push({
      name: 'page-entranceplant-badges',
    });
  }

  goToSwitchboards() {
    this.$router.push({
      name: 'page-entranceplant-switchboards',
    });
  }

  goToAddSwitchboard() {
    this.$router.push({
      name: 'page-entranceplant-switchboards',
      query: { addSwitchboard: 'add-switchboard' },
    });
  }

  goToAddressBook() {
    this.$router.push({
      name: 'page-entranceplant-residents',
    });
  }
}
